var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8542 4.9375H17.9375V7.8542C17.9375 7.9347 17.8722 8 17.7917 8H17.2083C17.1278 8 17.0625 7.9347 17.0625 7.8542V4.9375H14.1458C14.0653 4.9375 14 4.8722 14 4.7917V4.2083C14 4.1278 14.0653 4.0625 14.1458 4.0625H17.0625V1.1458C17.0625 1.0653 17.1278 1 17.2083 1H17.7917C17.8722 1 17.9375 1.0653 17.9375 1.1458V4.0625H20.8542C20.9347 4.0625 21 4.1278 21 4.2083V4.7917C21 4.8722 20.9347 4.9375 20.8542 4.9375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 13.25H9.0312L6.9062 11.125H1.5938C0.7135 11.125 0 11.8385 0 12.7188V22.2812C0 23.1615 0.7135 23.875 1.5938 23.875H15.4062C16.2865 23.875 17 23.1615 17 22.2812V14.8438C17 13.9635 16.2865 13.25 15.4062 13.25Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/AddFolder.75610682.svg";
export { ForwardRef as ReactComponent };